import { useEffect, useMemo } from 'react';
import Head from 'next/head';
import { Box, Grid } from 'theme-ui';
import { useProductByHandle } from '@backpackjs/storefront';

import { useDataLayerActions } from '@hooks';
import { Header } from './Header';
import { Media } from './Media';
import { Details } from './Details';
import { themed } from './Main.theme';

export const Main = themed(
  ({
    theme,
    product,
    selectedVariant,
    productUpsells,
    rebuyProducts,
    videoWise,
  }) => {
    const { product: currentProduct } = useProductByHandle({
      handle: selectedVariant?.product?.handle,
    });
    const { sendViewProductEvent } = useDataLayerActions();

    const titles = useMemo(() => {
      const titleArr = selectedVariant?.product?.title?.split('|');
      return {
        product: titleArr?.[0]?.trim() || '',
        variant: titleArr?.slice(1)?.join('|').trim() || '',
      };
    }, [selectedVariant?.product?.title]);

    useEffect(() => {
      sendViewProductEvent({ product, selectedVariant });
    }, [selectedVariant?.product?.handle, sendViewProductEvent]);

    return (
      <Grid data-comp={Main.displayName} sx={theme.wrapper}>
        <Head>
          <title>{currentProduct?.title || ''}</title>
        </Head>

        <Box sx={{ display: ['block', null, 'none'] }}>
          <Header
            selectedVariant={selectedVariant}
            currentProduct={currentProduct}
            titles={titles}
            isMobile
          />
        </Box>

        {/* Product images */}
        <Media
          product={currentProduct}
          selectedVariant={selectedVariant}
          aboveTheFold
          preload
        />

        {/* Title, Options, Add to cart */}
        <Details
          product={product}
          selectedVariant={selectedVariant}
          currentProduct={currentProduct}
          titles={titles}
          productUpsells={productUpsells}
          rebuyProducts={rebuyProducts}
          videoWise={videoWise}
        />
      </Grid>
    );
  }
);

Main.displayName = 'Main';
